import { t } from "@lingui/macro";
import * as React from "react";
import { Circle, ClipPath, Defs, G, Path, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const BocceBallIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Bocce Ball`} {...props}>
    <G clip-path="url(#clip0_7655_42670)" fill="none">
      <Circle cx="8" cy="8" r="7.25" stroke="currentColor" strokeWidth="1.5" />
      <Path
        d="M4 14V14C3.3379 10.0274 3.3379 5.9726 4 2V2"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <Path
        d="M15 9V9C10.3569 8.3367 5.6431 8.3367 1 9V9"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <Path
        d="M8 15V15C7.3367 10.3569 7.3367 5.6431 8 1V1"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <Path
        d="M15 5V5C10.3569 4.3367 5.6431 4.3367 1 5V5"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_7655_42670">
        <Rect width="16" height="16" fill="none" />
      </ClipPath>
    </Defs>
  </Icon>
);
